module.exports = __webpack_public_path__ + "static/unwomen-mockup-8c9207c8ee066cedab3c4aab8edcd1e9.png";